'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const LogoDecathlonWordmarkWhiteAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 149 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M18.4508 23.8001H31.6948V19.5441H23.4908V15.9741H30.7568V12.0121H23.4908V8.44211H31.6948V4.20011H18.4508V23.8001ZM48.1308 15.3581C46.2128 18.4101 44.3508 19.6841 41.9568 19.6841C38.8488 19.6841 37.0428 17.5001 37.0428 13.7061C37.0428 10.1081 38.7088 8.3161 41.2708 8.3161C42.9648 8.3161 44.3648 9.0721 44.7988 11.5921H49.8388C49.2928 6.79011 46.2268 3.80811 41.3268 3.80811C35.6428 3.80811 31.9048 7.8261 31.9048 13.9861C31.9048 20.1881 35.6428 24.1921 41.7888 24.1921C45.8068 24.1921 48.5368 22.5121 50.3428 20.2441H57.2168V23.8001H62.2288V4.20011H55.1168L48.1308 15.3581ZM57.2168 16.3101H52.7788L57.2168 9.10011V16.3101ZM7.69878 4.20011H0.334778V23.8001H7.69878C13.5368 23.8001 17.3028 19.9501 17.3028 14.0001C17.3028 8.05011 13.5368 4.20011 7.69878 4.20011ZM7.62878 19.5441H5.37477V8.44211H7.62878C10.5408 8.44211 12.1788 10.5001 12.1788 14.0001C12.1788 17.4861 10.5408 19.5441 7.62878 19.5441ZM120.077 3.80811C114.155 3.80811 110.179 7.8261 110.179 14.0001C110.179 20.1741 114.155 24.1921 120.077 24.1921C126.013 24.1921 129.975 20.1741 129.975 14.0001C129.975 7.82611 126.013 3.80811 120.077 3.80811ZM120.077 19.6841C117.165 19.6841 115.331 17.7381 115.331 14.0001C115.331 10.2621 117.165 8.3161 120.077 8.3161C123.003 8.3161 124.823 10.2621 124.823 14.0001C124.823 17.7381 123.003 19.6841 120.077 19.6841ZM63.4888 8.44211H68.4308V23.8001H73.4708V8.44211H78.4128V4.20011H63.4888L63.4888 8.44211ZM142.841 4.20011V14.9941L136.345 4.20011H131.123V23.8001H135.995V12.5581L142.757 23.8001H147.713V4.20011L142.841 4.20011ZM103.039 4.20011H97.9988V23.8001H110.641V19.5581H103.039V4.20011ZM91.5028 11.6761H84.7128V4.20011H79.6728V23.8001H84.7128V15.9041H91.5028V23.8001H96.5428V4.20011H91.5028V11.6761Z",
        fill: "white"
      }
    )
  }
);
const VpLogoDecathlonWordmarkWhiteAsset = forwardRef(LogoDecathlonWordmarkWhiteAsset);

export { VpLogoDecathlonWordmarkWhiteAsset as default };
